import { render, staticRenderFns } from "./UbicacionSection.vue?vue&type=template&id=60a0143d&scoped=true"
import script from "./UbicacionSection.vue?vue&type=script&lang=js"
export * from "./UbicacionSection.vue?vue&type=script&lang=js"
import style0 from "./UbicacionSection.vue?vue&type=style&index=0&id=60a0143d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0143d",
  null
  
)

export default component.exports